import { createSlice } from '@reduxjs/toolkit';
const ALL_OPTION = 'ALL';

const initialState = {
    totalElements: 0,
    aliases: [],
    firms: [],
    documents: [ALL_OPTION],
    loading: true,
    error: null,
}

const docTypeAliasMappingSlice = createSlice({
    name: 'docTypeAliasMapping',
    initialState,
    reducers: {
        loadingStarted(state) {
            state.loading = true;
            state.error = null;
        },
        loadingStopped(state) {
            state.loading = false;
        },
        loadingFailed(state, action) {
            state.loading = false;
            state.error = action.payload.error;
        },
        setAliases(state, action) {
            state.aliases = action.payload?.content || action.payload || [];
            state.totalElements = action.payload?.totalElements || 0;
            state.loading = false;
        },

        setFirms(state, action) {
            state.firms = [ALL_OPTION, ...(action.payload || [])];
        },
        aliasesLoaded(state, action) {
            state.aliases = action.payload.aliases;
            state.totalElements = action.payload.total;
        },
        firmsLoaded(state, action) {
            state.firms = action.payload.firms.sort((a, b) =>
                a.localeCompare(b, undefined, { sensitivity: 'base' })
            );
        },
    }
})

export const { actions: docTypeAliasMappingActions } = docTypeAliasMappingSlice;
export const docTypeAliasMappingReducer = docTypeAliasMappingSlice.reducer;
